/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Array of scores belonging to tag
 * @export
 * @interface TagActiveLearningScoresData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_TagActiveLearningScoresData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_TagActiveLearningScoresData_tagId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_TagActiveLearningScoresData_scoreType")("string")(() => {
    const regex = new RegExp(/^[a-zA-Z0-9_+=,.@:\/-]*$/);
    return (value: string) => !!regex.exec(value);
});
export interface TagActiveLearningScoresData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof TagActiveLearningScoresData
        
        
    * @pattern_TagActiveLearningScoresData_id
         */
    id: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof TagActiveLearningScoresData
        
        
    * @pattern_TagActiveLearningScoresData_tagId
         */
    tagId: string;
    /**
     * Type of active learning score
     * #type string
     * #memberof TagActiveLearningScoresData
        
        
    * @pattern_TagActiveLearningScoresData_scoreType
    * @minLength 1
         */
    scoreType: string;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof TagActiveLearningScoresData
        
    * @minimum 0
            
         */
    createdAt: number;
}
/**
 * Check if a given object implements the TagActiveLearningScoresData interface.
 */
export function instanceOfTagActiveLearningScoresData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "tagId" in value;
    isInstance = isInstance && "scoreType" in value;
    isInstance = isInstance && "createdAt" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const TagActiveLearningScoresDataTypiaAssertEquals = (input: any) => {
    return ((input: any): TagActiveLearningScoresData => {
        const __is = (input: any, _exceptionable: boolean = true): input is TagActiveLearningScoresData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_TagActiveLearningScoresData_id", "string", "", input.id) && ("string" === typeof input.tagId && $is_custom("pattern_TagActiveLearningScoresData_tagId", "string", "", input.tagId)) && ("string" === typeof input.scoreType && 1 <= input.scoreType.length && $is_custom("pattern_TagActiveLearningScoresData_scoreType", "string", "", input.scoreType)) && ("number" === typeof input.createdAt && 0 <= input.createdAt) && (4 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "tagId", "scoreType", "createdAt"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagActiveLearningScoresData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_TagActiveLearningScoresData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_TagActiveLearningScoresData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.tagId && ($is_custom("pattern_TagActiveLearningScoresData_tagId", "string", "", input.tagId) || $guard(_exceptionable, {
                    path: _path + ".tagId",
                    expected: "string (@pattern_TagActiveLearningScoresData_tagId)",
                    value: input.tagId
                })) || $guard(_exceptionable, {
                    path: _path + ".tagId",
                    expected: "string",
                    value: input.tagId
                })) && ("string" === typeof input.scoreType && (1 <= input.scoreType.length || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string (@minLength 1)",
                    value: input.scoreType
                })) && ($is_custom("pattern_TagActiveLearningScoresData_scoreType", "string", "", input.scoreType) || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string (@pattern_TagActiveLearningScoresData_scoreType)",
                    value: input.scoreType
                })) || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string",
                    value: input.scoreType
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && (4 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "tagId", "scoreType", "createdAt"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagActiveLearningScoresData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagActiveLearningScoresData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TagActiveLearningScoresDataTypiaAssertStringify = (input: TagActiveLearningScoresData): string => {
    return ((input: any): string => { const assert = (input: any): TagActiveLearningScoresData => {
        const __is = (input: any): input is TagActiveLearningScoresData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && $is_custom("pattern_TagActiveLearningScoresData_id", "string", "", (input as any).id) && ("string" === typeof (input as any).tagId && $is_custom("pattern_TagActiveLearningScoresData_tagId", "string", "", (input as any).tagId)) && ("string" === typeof (input as any).scoreType && 1 <= (input as any).scoreType.length && $is_custom("pattern_TagActiveLearningScoresData_scoreType", "string", "", (input as any).scoreType)) && ("number" === typeof (input as any).createdAt && !Number.isNaN((input as any).createdAt) && 0 <= (input as any).createdAt));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagActiveLearningScoresData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_TagActiveLearningScoresData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_TagActiveLearningScoresData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.tagId && ($is_custom("pattern_TagActiveLearningScoresData_tagId", "string", "", input.tagId) || $guard(_exceptionable, {
                    path: _path + ".tagId",
                    expected: "string (@pattern_TagActiveLearningScoresData_tagId)",
                    value: input.tagId
                })) || $guard(_exceptionable, {
                    path: _path + ".tagId",
                    expected: "string",
                    value: input.tagId
                })) && ("string" === typeof input.scoreType && (1 <= input.scoreType.length || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string (@minLength 1)",
                    value: input.scoreType
                })) && ($is_custom("pattern_TagActiveLearningScoresData_scoreType", "string", "", input.scoreType) || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string (@pattern_TagActiveLearningScoresData_scoreType)",
                    value: input.scoreType
                })) || $guard(_exceptionable, {
                    path: _path + ".scoreType",
                    expected: "string",
                    value: input.scoreType
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagActiveLearningScoresData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagActiveLearningScoresData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TagActiveLearningScoresData): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"id":${$string((input as any).id)},"tagId":${$string((input as any).tagId)},"scoreType":${$string((input as any).scoreType)},"createdAt":${(input as any).createdAt}}`;
    }; return stringify(assert(input)); })(input);
};
export const TagActiveLearningScoresDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'tagId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'scoreType': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]*$/).min(1).defined(),
    'createdAt': yup.number().min(0).defined(),
};
export const TagActiveLearningScoresDataValidator = yup.object().shape(TagActiveLearningScoresDataValidatorShape);
export const TagActiveLearningScoresDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'tagId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'scoreType': {
        'type': 'string',
        'pattern': "/^[a-zA-Z0-9_+&#x3D;,.@:\/-]*$/".slice(1, -1),
        'minLength': 1,
    } as unknown as fastJSON.StringSchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
};
export const TagActiveLearningScoresDataStringifyShape: ObjectSchema = {
    title: 'TagActiveLearningScoresData Stringifier',
    type: 'object',
    properties: {
        ...TagActiveLearningScoresDataStringifyShapeProperties
    },
    required: [
        'id',
        'tagId',
        'scoreType',
        'createdAt',
    ],
};
export const TagActiveLearningScoresDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagActiveLearningScoresDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TagActiveLearningScoresDataStringify: (data: TagActiveLearningScoresData) => string = TagActiveLearningScoresDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TagActiveLearningScoresDataFromJSON(json: any): TagActiveLearningScoresData {
    return TagActiveLearningScoresDataFromJSONTyped(json, false);
}
export function TagActiveLearningScoresDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagActiveLearningScoresData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'tagId': json['tagId'],
        'scoreType': json['scoreType'],
        'createdAt': json['createdAt'],
    };
}
export function TagActiveLearningScoresDataToJSON(value?: TagActiveLearningScoresData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'tagId': value.tagId,
        'scoreType': value.scoreType,
        'createdAt': value.createdAt,
    };
}
